/* eslint-disable no-param-reassign */
import produce from 'immer';
import {
  GET_ROLE,
  GET_ROLE_ERROR,
  GET_BANK,
  GET_BANK_ERROR,
  GET_BANK_EMPTY,
  GET_PAGE_WIDTH
} from 'src/actions/commonActions';

const initialState = {
  roles: [
    {
      id: 1,
      roleName: 'Admin',
      roleValue: '1'
    },
    {
      id: 2,
      roleName: 'User',
      roleValue: '2'
    }
  ],
  roleError: null,
  bankList: null,
  bankListError: null,
  pageWidth: null
};

const commonReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_ROLE: {
      const roles = action.payload;
      return produce(state, draft => {
        draft.roles = roles;
      });
    }
    case GET_ROLE_ERROR: {
      const roleError = action.payload;
      return produce(state, draft => {
        draft.roleError = roleError;
      });
    }
    case GET_BANK: {
      const bankList = action.payload;
      return produce(state, draft => {
        draft.bankList = bankList;
      });
    }
    case GET_BANK_ERROR: {
      const bankListError = action.payload;
      return produce(state, draft => {
        draft.bankListError = bankListError;
      });
    }
    case GET_BANK_EMPTY: {
      return produce(state, draft => {
        draft.bankList = null;
        draft.bankListError = null;
      });
    }
    case GET_PAGE_WIDTH: {
      return produce(state, draft => {
        draft.pageWidth = action.payload;
      });
    }
    default: {
      return state;
    }
  }
};

export default commonReducer;
